import React from 'react';
import PropTypes from 'prop-types';

export default class NumberValue extends React.Component {
	
	static propTypes = {
		value: PropTypes.any,
		emptyField: PropTypes.string,
		type: PropTypes.oneOf([ 'decimal', 'currency', 'percent' ]),
		options: PropTypes.object,
		fraction: PropTypes.number,
	};

	static defaultProps = {
		type: 'decimal',
	};
	
	format = val => {
		if (Number.isNaN(val)) return '?';
		
		let options = {};
		
		if (this.props.options) {
			options = this.props.options;
		}
		else {
			options = {
				style: this.props.type,
				minimumFractionDigits: this.props.fraction,
				maximumFractionDigits: this.props.fraction,
			};
			if (this.props.type === 'currency') {
				options.currency = 'RUB';
				options.minimumFractionDigits = 2;
				options.maximumFractionDigits = 2;
			}
		}
		return Number(val).toLocaleString(this.props.locales, options);
	};
	
	render() {
		const { value, emptyField, __data } = this.props;

		const _emptyField = emptyField || __data.emptyField || '-';

		return <span className="number-value">{value !== null && value !== undefined ? this.format(value) : _emptyField}</span>;
	}
}
